import React from 'react';

const PinterestWidget = () => {
  return (
    <>
      <h5>
        <b>Pinterest Widget</b>
      </h5>
      <p>
        The Pinterest widget plugin allows you to easily embed pins, profile board, etc. from
        Pinterest to your web app.
      </p>
      <br />
    </>
  );
};

export default PinterestWidget;
